/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { GoogleAuthenticationAuthGooglePostParams, HTTPValidationError } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class Auth<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name GoogleAuthenticationAuthGooglePost
   * @summary Google Authentication
   * @request POST:/auth/google
   * @response `200` `any` Successful Response
   * @response `422` `HTTPValidationError` Validation Error
   */
  googleAuthenticationAuthGooglePost = (query: GoogleAuthenticationAuthGooglePostParams, params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/auth/google`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    });
}
